export const permissionsConfigKey ='permissions';